export default __webpack_public_path__ + "34ec68d518a889c03b2bcff656574794.png";